import { render, staticRenderFns } from "./classInfoUser.vue?vue&type=template&id=d9d4dd46"
import script from "./classInfoUser.vue?vue&type=script&lang=js"
export * from "./classInfoUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports